/** User-facing definitions for Prompt Pulse metrics (hover tooltips). */
export const PROMPT_PULSE_METRIC_DEFINITIONS = {
  our_company_mentions:
    'Number of prompt runs in the selected range where your company was named in the AI response.',
  our_average_position:
    'When your company is mentioned, the average order it appears in the answer (1 = first). Lower is better. Averaged from rank/total in each response.',
  mention_share:
    'Share of prompt runs that mentioned your company: your mentions ÷ total runs × 100.',
  share_of_voice:
    'Your brand\'s mentions as a percentage of all brand mentions across you and selected competitors in the range.',
  active_prompts:
    'Prompts marked active in the query bank. Only active prompts are included in scheduled runs and insights.',
  mention_share_over_time:
    'Daily mention share for your company and top competitors: brand hits that day ÷ total runs that day × 100.',
  ai_visibility_index:
    'Plots mention share (horizontal) vs likelihood to buy (vertical) for each brand. Likelihood is derived from average mention rank, with sentiment adjustment for your company.',
  company_ranking:
    'Brands ranked by total mentions in the range, with mention share, share of voice, and sentiment for your company.',
  top_prompts:
    'Prompts with the most mentions of your company in the selected range.',
  citations:
    'Most-cited URLs in model responses for the selected date range and filters, across all companies.',
  citations_over_time:
    'Daily count of your website URLs cited in AI responses across active prompts in the selected range.',
  citation_share:
    'Each URL\'s citations as a percentage of all citations in the range.',
  coverage_pct:
    'For a prompt: runs where your company was mentioned ÷ total runs for that prompt × 100.',
  avg_position:
    'Average mention order when your company appears in responses for that prompt. Lower is better.',
  overall_sentiment:
    'Average sentiment when your company is mentioned: positive = +1, neutral = 0, negative = −1. The pill shows positive if the average is above 0, negative if below 0, otherwise neutral.',
  our_mentions:
    'Number of runs in the range where your company was mentioned for this prompt.',
  sov:
    'Share of voice: this brand\'s mentions ÷ all tracked brand mentions × 100.',
  mention_share_column:
    'Share of runs in the range where this brand was mentioned: brand hits ÷ total runs × 100.',
  likelihood_to_buy:
    'Score from 0–100 based on average mention rank in responses, adjusted for sentiment on your company. Higher means the brand tends to appear earlier and more favorably.',
  purchase_intent:
    'Same as likelihood to buy: a 0–100 score from mention rank in AI answers, with sentiment adjustment for your company.',
};

export function getPromptPulseMetricDefinition(key) {
  return PROMPT_PULSE_METRIC_DEFINITIONS[key] || '';
}
